/*
 * top.js
 */

// import jQuery from 'jquery';  //node_modlesの中にあるものを使用探しに行ってくれる
import $ from 'jquery';
import 'jquery.cookie';
import 'slick-carousel';
import '../scss/style.scss';

$(function(){
/* ==========================================================
!for Top
========================================================== */


/* おすすめ物件用スライド
-------------------------------------------------- */
$('.js-tpRecommendSlide').slick({
  fade: true,
  arrow: true,
  dots: true,
  autoplay: true,
	autoplaySpeed: 2000,
  appendDots: $('.slick-controler'),
  appendArrows: $('.slick-controler'),
});
$(".js-tpRecommendSlide__pause").on("click", function() {
	//一時停止中なら
	if($(this).hasClass("paused")){
		//再開
		$(".js-tpRecommendSlide").slick("slickPlay");
		//「.paused」削除
		$(this).removeClass("paused");
	}else{
		//再生中なら
		//一時停止
		$(".js-tpRecommendSlide").slick("slickPause");
		//「.paused」付与
		$(this).addClass("paused");
	}
});

/* 採用情報用スライド
-------------------------------------------------- */
  $('.js-tpRecruitSlide')
  .on("init", function(event, slick) {
    // $(this).append(
    //   '<div class="slick-count"><span class="now-count"></span>/<span class="all-count"></span></div>'
    // );
    $(".now-count").text(slick.currentSlide + 1);
    $(".all-count").text(slick.slideCount);
  })
  .slick({
    autoplay: false,
    arrows: true,
    slidesToShow: 4,
		slidesToScroll: 1,
    responsive: [
			{
				breakpoint: 1070,
				settings: {
					slidesToShow:2,
          variableWidth: true,
				}
			}
		]
  })
  .on("beforeChange", function(event, slick, currentSlide, nextSlide) {
    $(".now-count").text(nextSlide + 1);
  });;

/* ニュース・トピックス絞り込み機能
-------------------------------------------------- */
  const $filterBtns = $('.js-newsFilter [data-filter]');
  const $newsList = $('.js-newsList [data-category]');
  
  $filterBtns.on('click', function() {
    var $btnTxt = $(this).attr('data-filter');
    
    if ($btnTxt == 'all'){
      $newsList.fadeIn();
    } else {
      $newsList.hide();
      $newsList.filter('[data-category = "' + $btnTxt + '"]').fadeIn();
    }
  });

});
